import * as ExcelJS from 'exceljs';

export const safeMerge = (
  sheet: ExcelJS.Worksheet,
  r1: number,
  c1: number,
  r2: number,
  c2: number
) => {
  const colToLetter = (col: number) => {
    let letter = '';
    while (col > 0) {
      const mod = (col - 1) % 26;
      letter = String.fromCharCode(65 + mod) + letter;
      col = Math.floor((col - mod) / 26);
    }
    return letter;
  };

  const cellAddressToNumbers = (cellAddress: string): [number, number] => {
    const colLetter = cellAddress.replace(/[0-9]/g, '');
    const rowNumber = parseInt(cellAddress.replace(/\D/g, ''));

    let colNumber = 0;
    for (let i = 0; i < colLetter.length; i++) {
      colNumber += (colLetter.charCodeAt(i) - 64) * Math.pow(26, colLetter.length - i - 1);
    }
    return [rowNumber, colNumber];
  };

  const startCell = `${colToLetter(c1)}${r1}`;
  const endCell = `${colToLetter(c2)}${r2}`;
  const range = `${startCell}:${endCell}`;

  try {
    // Unmerge any existing merged range that overlaps with the target range
    const merges: string[] = ((sheet as unknown) as { model?: { merges?: string[] } }).model?.merges || [];
    for (const mergedRange of merges) {
      const [topLeft, bottomRight] = mergedRange.split(':');
      const [topRow, leftCol] = cellAddressToNumbers(topLeft);
      const [bottomRow, rightCol] = cellAddressToNumbers(bottomRight);

      const overlaps = !(r2 < topRow || r1 > bottomRow || c2 < leftCol || c1 > rightCol);
      if (overlaps) {
        try {
          sheet.unMergeCells(mergedRange);
        } catch (_) {
          // ignore
        }
      }
    }

    // Finally perform the intended merge if it's not a single cell
    if (r1 !== r2 || c1 !== c2) {
      try {
        sheet.unMergeCells(range);
      } catch (_) {
        // ignore if not merged
      }
      sheet.mergeCells(range);
    }
  } catch (e) {
  }

};
